import { loadStripe } from '@stripe/stripe-js';

const stripeTestPublicKey = 'pk_test_m3fJcty1Wp3FBCYE9IJ89gvf00xADPpIZT';
const stripeLivePublicKey = 'pk_live_YGg56Lp2J6AFYlY7AmwWJ6FY00Kw7Pcr6m';
const pvEnv = process.env.REACT_APP_PV_ENV as string;

const stripePublicKey =
  pvEnv === 'production' ? stripeLivePublicKey : stripeTestPublicKey;

const stripePromise = loadStripe(stripePublicKey);
const connectedStripePromises = new Map<string, ReturnType<typeof loadStripe>>();

export const getStripePromise = (stripeAccount?: string | null) => {
  if (!stripeAccount) {
    return stripePromise;
  }

  if (!connectedStripePromises.has(stripeAccount)) {
    connectedStripePromises.set(
      stripeAccount,
      loadStripe(stripePublicKey, { stripeAccount })
    );
  }

  return connectedStripePromises.get(stripeAccount) as ReturnType<
    typeof loadStripe
  >;
};

export const useStripeLoader = () => stripePromise;
